module.exports = __webpack_public_path__ + "img/icon-facebook.0beaec36.svg";